export default __webpack_public_path__ + "static/media/20.c209fa62.jpg";